<template>
    <v-layout justify-center>
        <v-responsive max-width="1280px" width="100%" height="100%">
            <v-row class="mt-8" justify="center" align="center">
                <v-col cols="auto" class="pt-0 pb-0 headline text-start">Before & After 목록</v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pt-0 pb-0">
                    <v-btn class="ma-2" color="secondary" rounded @click="showSearch = !showSearch"><v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터</v-btn>
                </v-col>
            </v-row>

            <v-expand-transition>
                <v-card v-show="showSearch" class="elevation-1 mx-auto">
                    <v-card-title class="subtitle-2 font-weight-bold">검색필터</v-card-title>


                    <v-card-actions class="pt-0">
                        <v-spacer></v-spacer>
                        <v-btn color="primary" rounded text @click="search"><v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색</v-btn>
                    </v-card-actions>
                </v-card>
            </v-expand-transition>

            <v-data-table :headers="headers" :items="contents" disable-sort disable-pagination hide-default-footer class="elevation-1 mt-4">
                <template v-slot:item.name="{item}">
                    <v-row align="center">
                        <v-col>
                            <span v-if="item.portfolio.user">{{ item.portfolio.user.meta.companyName }}</span>
                            <span v-else>-</span>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.before="{item}">
                    <v-row align="center">
                        <v-col md="auto">
                            <v-img v-if="item.beforeImage" :src="`/${item.beforeImage.path}`" max-width="56" max-height="56"></v-img>
                            <v-responsive v-else width="56" height="56">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.after="{item}">
                    <v-row align="center">
                        <v-col md="auto">
                            <v-img v-if="item.image" :src="`/${item.image.path}`" max-width="56" max-height="56"></v-img>
                            <v-responsive v-else width="56" height="56">
                                <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                    <v-icon>mdi-image</v-icon>
                                </v-row>
                            </v-responsive>
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.category="{item}">
                    <v-row align="center">
                        <v-col>
                            {{ item.portfolio.category.name }}
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.scope="{item}">
                    <v-row align="center">
                        <v-col>
                            {{ item.portfolio.scope }}
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.area="{item}">
                    <v-row align="center">
                        <v-col>
                            {{ item.portfolio.area }}평대
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.price="{item}">
                    <v-row align="center">
                        <v-col>
                            {{ item.portfolio.price }}천만원대
                        </v-col>
                    </v-row>
                </template>

                <template v-slot:item.main="{item}">
                    <v-row align="center" justify="center">
                        <v-col cols="auto" class="py-0">
                            <v-switch color="green" dense hide-details class="ma-0 pa-0" @change="putContent(item)" v-model="item.main"></v-switch>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" class="mt-4 mb-12" @input="search(false)"></v-pagination>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

export default {
    data : () => {
        return {
            showSearch : true,

            page : 1,
            limit : 3,
            pageCount : 0,

            contents : [],

            headers : [
                {
                    text: '업체명',
                    align: 'center',
                    width: 100,
                    value: 'name'
                },
                {
                    text: '시공전',
                    align: 'center',
                    width: 100,
                    value: 'before'
                },
                {
                    text: '시공후',
                    align: 'center',
                    width: 100,
                    value: 'after'
                },
                {
                    text: '카테고리',
                    align: 'center',
                    width: 100,
                    value: 'category'
                },
                {
                    text: '시공범위',
                    align: 'center',
                    width: 100,
                    value: 'scope'
                },
                {
                    text: '평수',
                    align: 'center',
                    width: 100,
                    value: 'area'
                },
                {
                    text: '가격',
                    align: 'center',
                    width: 100,
                    value: 'price'
                },
                {
                    text: '메인노출',
                    align: 'center',
                    width: 100,
                    value: 'main'
                },
            ]
        }
    },
    mounted() {
        this.init();
    },
    methods : {
        putContent(item) {
            return new Promise(async (resolve,reject) => {
                try{
                    await this.$http.put(`/api/console/portfolio/admin/content/${item._id}`, item, {
                        headers : {

                        }
                    });

                    resolve();
                }catch(error) {
                    reject(error);
                }
            });
        },
        async init() {
            try{
                this.search(false);
            }catch(error) {
                console.error(error);
            }
        },
        async search(routable = true){
            try{
                if(routable){
                    this.$router.push({
                        query: Object.assign({}, this.filter, { page: this.page })
                    });
                }

                var { summary, contents } = await api.console.portfolios.contents.getContents(undefined, {
                    headers : {
                        skip : (this.page -1) * this.limit,
                        limit : this.limit
                    },
                    params: this.filter
                });

                this.contents = contents;
                this.pageCount = Math.ceil(summary.totalCount / this.limit);

            }catch(error) {
                console.error(error);
            }
        },
        getContents() {
            return new Promise(async (resolve,reject) => {
                try{
                    var res = await this.$http.get(`/api/console/portfolio/admin/contents` , {
                        headers : {
                            skip : (this.page -1) * this.limit,
                            limit : this.limit
                        }
                    });
                    this.contents = res.data.contents;
                    this.pageCount = Math.ceil(res.data.summary.totalCount / this.limit);
                    resolve();
                }catch(error) {
                    reject(error);
                }
            });
        }
    },
    watch : {
        page() {
            this.getContents();
        }
    }
}
</script>

<style lang="css" scoped>
</style>
